import { createReducer } from '@reduxjs/toolkit';
import { initialUserState as initialState } from './state';
import * as actions from './action';
import { setNestedField } from '../utils';

export default createReducer(initialState(), (builder) => {
  builder
    .addCase(actions.setUser, (state, { payload: { field, value } }) => {
      setNestedField(state, field, value);
    })
    .addCase(actions.setCurrentUser, (state, { payload }) => {
      state.current_user = payload;
    })
    .addCase(actions.resetUser, (state) => {
      return initialState();
    });
});
